<template>
  <EditFormDialog
    :formData="formData"
    :rules="rules"
    :formType="'update'"
    :loading="loading"
    :formVisible="formVisible"
    @submitForm="submitForm"
    v-bind="$attrs"
    v-on="$listeners"
  >

    <el-form-item :label="$t('dui-jie-ping-tai-de-zu-zhi-ji-gou-dai-ma')" prop="companyCode">
      <el-input v-model="formData.companyCode" maxlength="32" show-word-limit style="width:90%" autocomplete="off" :placeholder="$t('qing-tian-xie-10')"
                clearable></el-input>
    </el-form-item>

    <el-form-item :label="$t('gong-si-ming-cheng')">
      <el-input v-model="formData.companyName" autocomplete="off" :placeholder="$t('qing-tian-xie-10')"
                maxlength="50"
                show-word-limit
                type="textarea"
                :rows="3"
                clearable></el-input>
    </el-form-item>

    <el-form-item :label="$t('dui-jie-url')" prop="companyUrl">
      <el-input v-model="formData.companyUrl" autocomplete="off" :placeholder="$t('qing-tian-xie-10')"
                maxlength="100"
                show-word-limit
                type="textarea"
                :rows="3"
                clearable></el-input>
    </el-form-item>

    <el-form-item :label="$t('tui-song-url')" prop="pushUrl">
      <el-input v-model="formData.pushUrl" autocomplete="off" :placeholder="$t('qing-tian-xie-10')"
                maxlength="100"
                show-word-limit
                type="textarea"
                :rows="3"
                clearable></el-input>
    </el-form-item>

    <el-form-item :label="$t('dui-jie-miao-shu')">
      <el-input v-model="formData.description" autocomplete="off"
                maxlength="100"
                show-word-limit
                type="textarea"
                :rows="3"
                :placeholder="$t('qing-tian-xie-10')"></el-input>
    </el-form-item>

    <el-form-item :label="$t('yun-ying-shang-ming-cheng')">
      <el-input v-model="formData.operatorName" autocomplete="off"
                maxlength="100"
                show-word-limit
                type="textarea"
                :rows="3"
                :placeholder="$t('qing-tian-xie-10')"></el-input>
    </el-form-item>

    <el-form-item :label="$t('yun-ying-shang-jian-cheng')">
      <el-input v-model="formData.operatorBname" autocomplete="off"
                maxlength="100"
                show-word-limit
                type="textarea"
                :rows="3"
                :placeholder="$t('qing-tian-xie-10')"></el-input>
    </el-form-item>

    <el-form-item :label="$t('yun-ying-shang-ke-fu-dian-hua')">
      <el-input v-model="formData.operatorTel1" autocomplete="off"
                maxlength="100"
                show-word-limit
                type="textarea"
                :rows="3"
                :placeholder="$t('qing-tian-xie-10')"></el-input>
    </el-form-item>

    <el-form-item :label="$t('yun-ying-shang-zhu-ce-di-zhi')">
      <el-input v-model="formData.operatorRegAddress" autocomplete="off"
                maxlength="100"
                show-word-limit
                type="textarea"
                :rows="3"
                :placeholder="$t('qing-tian-xie-10')"></el-input>
    </el-form-item>

    <el-form-item :label="$t('shi-fou-you-xiao')" prop="isAvailable">
      <el-select v-model="formData.isAvailable" :placeholder="$t('xuan-ze-shi-fou')">
        <el-option v-for="item in searchData.yesOrNo" :key="item.value" v-bind:label="item.message"
                   v-bind:value="item.value"/>
      </el-select>
    </el-form-item>


    <el-form-item :label="$t('gong-xiang-zhan-dian-ming-cheng')" prop="sites">
      <el-select multiple filterable
                 @remove-tag="removeTag"
                 @change="selectStation"
                 @clear="clearAll"
                 v-model="formData.sites"
                 :placeholder="$t('qing-xuan-ze-zhan-dian')">
        <el-option v-for="item in searchData.stations" :key="item.id" v-bind:label="item.stationName"
                   v-bind:value="item.id">
        </el-option>
      </el-select>
      <template>
        <el-checkbox @change="selectSites" v-model="checked">{{ $t('quan-xuan') }}</el-checkbox>
      </template>
    </el-form-item>

    <el-form-item :label="$t('kai-fang-jie-kou')" prop="interfaces">
      <el-select v-model="formData.interfaces" multiple :placeholder="$t('qing-xuan-ze-jie-kou')">
        <el-option v-for="item in searchData.interfaceNames" :key="item.interfaceName"
                   v-bind:label="item.interfaceName" v-bind:value="item.interfaceName">
        </el-option>
      </el-select>
    </el-form-item>

    <el-form-item :label="$t('tui-song-pin-shuai-miao')" prop="frequency">
      <el-input   v-model="formData.frequency" maxlength="6" show-word-limit style="width:90%" autocomplete="off" :placeholder="$t('qing-tian-xie-10')"
                  clearable></el-input>
    </el-form-item>

    <el-form-item label="运营商统一社会信用代码" prop="operatorUSCID">
      <el-input v-model="formData.operatorUSCID" maxlength="20" show-word-limit style="width:90%" autocomplete="off" placeholder="请填写"
                clearable></el-input>
    </el-form-item>

    <el-form-item :label="$t('yun-ying-shang-de-zu-zhi-ji-gou-dai-ma')" prop="operatorid">
      <el-input   v-model="formData.operatorid" maxlength="9" show-word-limit style="width:90%" autocomplete="off" :placeholder="$t('qing-tian-xie-10')"
                clearable></el-input>
    </el-form-item>

    <el-form-item :label="$t('yun-ying-shang-mi-yue-ben-ping-tai')" prop="operatorSecret">
      <el-input   v-model="formData.operatorSecret" maxlength="1000" type="textarea" show-word-limit style="width:90%" autocomplete="off" placeholder="OperatorSecret"
                clearable></el-input>
    </el-form-item>

    <el-form-item :label="$t('xiao-xi-mi-yue-ben-ping-tai')" prop="dataSecret">
      <el-input   v-model="formData.dataSecret" maxlength="32" show-word-limit style="width:90%" autocomplete="off" placeholder="DataSecret"
                clearable></el-input>
    </el-form-item>

    <el-form-item :label="$t('xiao-xi-mi-yue-xiang-liang-ben-ping-tai')" prop="dataSecretIv">
      <el-input   v-model="formData.dataSecretIv" maxlength="32" show-word-limit style="width:90%" autocomplete="off" placeholder="DataSecretIV"
                clearable></el-input>
    </el-form-item>

    <el-form-item :label="$t('qian-ming-mi-yue-ben-ping-tai')" prop="sigSecret">
      <el-input v-model="formData.sigSecret" maxlength="32" show-word-limit style="width:90%" autocomplete="off" placeholder="SigSecret"
                clearable></el-input>
    </el-form-item>

    <el-form-item :label="$t('yun-ying-shang-mi-yue-di-san-fang')" prop="thirdOperatorSecret">
      <el-input   v-model="formData.thirdOperatorSecret" maxlength="1000" type="textarea" show-word-limit style="width:90%" autocomplete="off" placeholder="OperatorSecret"
                  clearable></el-input>
    </el-form-item>

    <el-form-item :label="$t('xiao-xi-mi-yue-di-san-fang')" prop="thirdDataSecret">
      <el-input   v-model="formData.thirdDataSecret" maxlength="32" show-word-limit style="width:90%" autocomplete="off" placeholder="DataSecret"
                  clearable></el-input>
    </el-form-item>

    <el-form-item :label="$t('xiao-xi-mi-yue-xiang-liang-di-san-fang')" prop="thirdDataSecretIv">
      <el-input   v-model="formData.thirdDataSecretIv" maxlength="32" show-word-limit style="width:90%" autocomplete="off" placeholder="DataSecretIV"
                  clearable></el-input>
    </el-form-item>

    <el-form-item :label="$t('qian-ming-mi-yue-di-san-fang')" prop="thirdSigSecret">
      <el-input v-model="formData.thirdSigSecret" maxlength="32" show-word-limit style="width:90%" autocomplete="off" placeholder="SigSecret"
                clearable></el-input>
    </el-form-item>

    <el-form-item :label="$t('kai-piao-id')" prop="clientId">
      <el-input v-model="formData.clientId" maxlength="64" show-word-limit style="width:90%" autocomplete="off" :placeholder="$t('qing-tian-xie-10')"
                clearable></el-input>
    </el-form-item>

    <el-form-item :label="$t('kai-piao-secret')" prop="clientSecret">
      <el-input v-model="formData.clientSecret" maxlength="64" show-word-limit style="width:90%" autocomplete="off" :placeholder="$t('qing-tian-xie-10')"
                clearable></el-input>
    </el-form-item>
    <el-form-item :label="$t('ping-tai-bao-zheng-jin-e')" prop="bondAmount">
      <el-input
        clearable
        maxlength="18"
        show-word-limit style="width:90%"
        v-model="formData.bondAmount"
        :placeholder="$t('qing-shu-ru-0')"></el-input>
    </el-form-item>
    <el-form-item :label="$t('ping-tai-gao-jing-jin-e')" prop="alarmAmount">
      <el-input
        clearable
        maxlength="18"
        show-word-limit style="width:90%"
        v-model="formData.alarmAmount"
        :placeholder="$t('bao-zheng-jin-di-yu-gai-jine12-bu-yun-xu-qi-dong-chong-dian')"></el-input>
    </el-form-item>

  </EditFormDialog>
</template>
<script>
    import api from '@/module/interactionCenter/api/cec.js'
    import EditFormDialog from '@/components/EditFormDialog'
    import {validateInput} from '../../../../../common/validator'


    export default {
        props: {
            searchData: {
                type: Object,
                required: true
            },
            selectRowData: {
                type: Object,
                required: true
            },
            formVisible: {
                type: Boolean,
                required: true
            }
        },
        components: {
            EditFormDialog
        },
        data() {
            return {
                checked:false,
                loading: false, // 是显示加载
                fileList: [{name: '', url: ''}],
                dialogImageUrl: '',
                dialogVisible: false,
                imageVisible: false,
                textVisible: true,
                position: [],
                currentPosition: null,
                filterPosition: null,
                // 表单
                formData: {
                    id: '',
                    companyCode: '',
                    companyName: '',
                    companyUrl: '',
                    pushUrl: '',
                    isAvailable: '',
                    description: '',
                    createTime: '',
                    operatorid: '',
                    operatorUSCID: '',
                    operatorName: '',
                    operatorBname:'',
                    operatorTel1:'',
                    operatorRegAddress:'',
                    dataSecretIv: '',
                    operatorSecret: '',
                    dataSecret: '',
                    sigSecret: '',
                    sites: [],
                    interfaces: [],
                    bondAmount: 0,
                    alarmAmount: 0,
                },
                // rules表单验证
                rules: {
                    companyCode: [{required: true, message: this.$t('qing-shu-ru-zu-zhi-ji-gou-dai-ma'), trigger: 'blur'},
                        {max: 32, message: this.$t('zu-zhi-ji-gou-dai-ma-bu-neng-chao-guo-9-wei'), trigger: 'blur'}],
                    companyUrl: [{required: true, message: this.$t('qing-shu-ru-dui-jie-url'), trigger: 'blur'},
                        {
                            validator: function (rule, value, callback) {
                                validateInput(rule, value, callback, 0, 100, true, false, true, false, false, false, false)
                            }, required: true, trigger: 'blur'
                        }
                    ],
                    pushUrl: [{required: true, message: this.$t('qing-shu-ru-tui-song-url'), trigger: 'blur'},
                        {
                            validator: function (rule, value, callback) {
                                validateInput(rule, value, callback, 0, 100, true, false, true, false, false, false, false)
                            }, required: true, trigger: 'blur'
                        }
                    ],
                    isAvailable: [{required: true, message: this.$t('qing-xuan-ze-shi-fou-you-xiao'), trigger: 'blur'}],
                    operatorid: [{required: true, message: this.$t('qing-shu-ru-yun-ying-shang-id'), trigger: 'blur'},
                        {
                            validator: function (rule, value, callback) {
                                validateInput(rule, value, callback, 0, 9, true, false, true, false, false, false, false)
                            }, required: true, trigger: 'blur'
                        }
                    ],
                    operatorUSCID: [{required: true, message: '统一社会信用代码', trigger: 'blur'}],
                    sites: [{required: true, message: this.$t('qing-xuan-ze-gong-xiang-zhan-dian'), trigger: 'blur'}],
                    interfaces: [{required: true, message: this.$t('qing-xuan-ze-kai-fang-jie-kou'), trigger: 'blur'}],
                    operatorSecret: [{
                        validator: function (rule, value, callback) {
                            validateInput(rule, value, callback, 0, 1000, true, false, true, false, false, false, false)
                        }, required: false, trigger: 'blur'
                    }],
                    dataSecret: [{
                        validator: function (rule, value, callback) {
                            validateInput(rule, value, callback, 0, 64, true, false, true, false, false, false, false)
                        }, required: false, trigger: 'blur'
                    }],
                    dataSecretIv: [{
                        validator: function (rule, value, callback) {
                            validateInput(rule, value, callback, 0, 64, true, false, true, false, false, false, false)
                        }, required: false, trigger: 'blur'
                    }],
                    sigSecret: [{
                        validator: function (rule, value, callback) {
                            validateInput(rule, value, callback, 0, 64, true, false, true, false, false, false, false)
                        }, required: false, trigger: 'blur'
                    }]
                }
            }
        },
        created() {
        },
        watch: {
            formVisible: {
                handler: 'getData',
                immediate: true
            },
        },
        methods: {
          selectSites(dx){
            let siteIds = [];
            if(dx){
              this.searchData.stations.forEach(function(val){
                //console.log(val.id+"-"+val.stationName+"\n");
                siteIds.push(val.id);
              });
              this.formData.sites=siteIds;
            }else{
              this.formData.sites=siteIds;
            }
          },
          /**/
          selectStation(val){
            console.log(val);
            console.log(this.formData.sites);
            //this.searchData.stations
            if (this.searchData.stations.length !== this.formData.sites.length) {
              this.checked = false;
            } else {
              this.checked = true;
            }
          },
          /*移除select的tag*/
          removeTag(value){
            console.log(value);
            this.checked = false;
          },
          clearAll(){
            this.checked = false;
          },
            getData() {
                if (this.formVisible && this.selectRowData && this.selectRowData.id) {
                    this.loading = true
                    api.getDtoById(this.selectRowData.id).then(res => {
                        this.loading = false
                        if (res.code === 0) {
                            this.formData = res.data
                            if (this.searchData.stations.length !== this.formData.sites.length) {
                              this.checked = false;
                            } else {
                              this.checked = true;
                            }
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                }
            },
            // 编辑、添加提交方法
            submitForm() {
                api.update(this.formData).then((res) => {
                    if (res.code === 0) {
                        this.$message({
                            type: 'success',
                            message: this.$t('paramMonitor.message22')
                        })
                        this.$emit('afterUpdate')
                    } else {
                        this.$message.error(res.message)
                    }
                }).finally(() => {
                    this.loading = false
                })
            },
        }
    }
</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/module/interactionCenter/page/cec/cec/update.vue